import request, { toFormData } from '@/utils/request'

export function login(data) {
  return request({ url: '/login', method: 'post', data: toFormData(data) })
}

export function getInfo() {
  return request({ url: '/info', method: 'get' })
}

export function logout() {
  return request({ url: '/logout', method: 'post' })
}

export function getDashboard() {
  return request({ url: '/dashboard', method: 'get' })
}

// Admin users
export function getAdminList(params) {
  return request({ url: '/admin/list', method: 'get', params })
}
export function saveAdmin(data) {
  return request({ url: '/admin/save', method: 'post', data: toFormData(data) })
}
export function deleteAdmin(id) {
  return request({ url: '/admin/delete', method: 'post', data: toFormData({ id }) })
}

// Roles
export function getRoleList() {
  return request({ url: '/role/list', method: 'get' })
}
export function saveRole(data) {
  return request({ url: '/role/save', method: 'post', data: toFormData(data) })
}
export function deleteRole(id) {
  return request({ url: '/role/delete', method: 'post', data: toFormData({ id }) })
}
export function getRolePermissions(roleId) {
  return request({ url: '/role/permissions', method: 'get', params: { role_id: roleId } })
}

// Permissions
export function getPermissionList() {
  return request({ url: '/permission/list', method: 'get' })
}
export function savePermission(data) {
  return request({ url: '/permission/save', method: 'post', data: toFormData(data) })
}
export function deletePermission(id) {
  return request({ url: '/permission/delete', method: 'post', data: toFormData({ id }) })
}

// Wechat config
export function getWechatConfig() {
  return request({ url: '/wechat/config', method: 'get' })
}
export function saveWechatConfig(data) {
  return request({ url: '/wechat/config', method: 'post', data: toFormData(data) })
}

// Business
export function getUserList(params) {
  return request({ url: '/user/list', method: 'get', params })
}
export function getDriverList(params) {
  return request({ url: '/driver/list', method: 'get', params })
}
export function auditDriver(data) {
  return request({ url: '/driver/audit', method: 'post', data: toFormData(data) })
}
export function saveDriver(data) {
  return request({ url: '/driver/save', method: 'post', data: toFormData(data) })
}
export function deleteDriver(id) {
  return request({ url: '/driver/delete', method: 'post', data: toFormData({ id }) })
}
export function getCategoryList() {
  return request({ url: '/category/list', method: 'get' })
}
export function saveCategory(data) {
  return request({ url: '/category/save', method: 'post', data: toFormData(data) })
}
export function deleteCategory(id) {
  return request({ url: '/category/delete', method: 'post', data: toFormData({ id }) })
}
export function getBannerList() {
  return request({ url: '/banner/list', method: 'get' })
}
export function saveBanner(data) {
  return request({ url: '/banner/save', method: 'post', data: toFormData(data) })
}
export function deleteBanner(id) {
  return request({ url: '/banner/delete', method: 'post', data: toFormData({ id }) })
}
export function uploadImage(data) {
  return request({ url: '/upload/image', method: 'post', data })
}
export function getServiceList(params) {
  return request({ url: '/service/list', method: 'get', params })
}
export function saveService(data) {
  return request({ url: '/service/save', method: 'post', data: toFormData(data) })
}
export function deleteService(id) {
  return request({ url: '/service/delete', method: 'post', data: toFormData({ id }) })
}
export function getOrderList(params) {
  return request({ url: '/order/list', method: 'get', params })
}
export function auditOrder(id) {
  return request({ url: '/order/audit', method: 'post', data: toFormData({ id }) })
}
export function getWithdrawList(params) {
  return request({ url: '/withdraw/list', method: 'get', params })
}
export function auditWithdraw(data) {
  return request({ url: '/withdraw/audit', method: 'post', data: toFormData(data) })
}

// Logs
export function getAdminLog(params) {
  return request({ url: '/log/admin', method: 'get', params })
}
export function getUserLog(params) {
  return request({ url: '/log/user', method: 'get', params })
}
export function getDriverLog(params) {
  return request({ url: '/log/driver', method: 'get', params })
}

// Operation
export function getAnnouncementList() { return request({ url: '/announcement/list', method: 'get' }) }
export function saveAnnouncement(data) { return request({ url: '/announcement/save', method: 'post', data: toFormData(data) }) }
export function deleteAnnouncement(id) { return request({ url: '/announcement/delete', method: 'post', data: toFormData({ id }) }) }
export function getAppealList(params) { return request({ url: '/appeal/list', method: 'get', params }) }
export function handleAppeal(data) { return request({ url: '/appeal/handle', method: 'post', data: toFormData(data) }) }
export function getRealnameList(params) { return request({ url: '/realname/list', method: 'get', params }) }
export function auditRealname(data) { return request({ url: '/realname/audit', method: 'post', data: toFormData(data) }) }
export function getUserFinanceList(params) { return request({ url: '/userFinance/list', method: 'get', params }) }
export function getDriverApplyList(params) { return request({ url: '/driverApply/list', method: 'get', params }) }
export function auditDriverApply(data) { return request({ url: '/driverApply/audit', method: 'post', data: toFormData(data) }) }
